import { eTipoPermissao } from '@/enums/ePermissoes';

export default [
  {
    description: 'Integração SETE',
    path: '/transporte/integracaoSETE',
    name: 'integracaoSETE',
    component: () => import('@/views/transporte/integracaoSETE/Index.vue'),
    meta: { permissions: [eTipoPermissao.INTEGRACAOSETENOVO_MENU_1100400999] },
    goesToMenu: true,
  },
];
